/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 0.10.0 - 2014-01-13
 * License: MIT
 */
angular.module("ui.bootstrap", [
    "ui.bootstrap.transition",
    "ui.bootstrap.collapse",
    "ui.bootstrap.accordion",
    "ui.bootstrap.alert",
    "ui.bootstrap.bindHtml",
    "ui.bootstrap.buttons",
    "ui.bootstrap.carousel",
    "ui.bootstrap.position",
    "ui.bootstrap.datepicker",
    "ui.bootstrap.dropdownToggle",
    "ui.bootstrap.modal",
    "ui.bootstrap.pagination",
    "ui.bootstrap.tooltip",
    "ui.bootstrap.popover",
    "ui.bootstrap.progressbar",
    "ui.bootstrap.rating",
    "ui.bootstrap.tabs",
    "ui.bootstrap.timepicker",
    "ui.bootstrap.typeahead"
]);
